<template>
  <div id="proile-settings">
    <b-tabs pills card>
      <b-tab title="Основная информация">
        <b-form v-on:submit.prevent="onSubmit" id="profile-form">
          <b-form-group id="last_nameInputGroup1" label="Фамилия:" label-for="last_name">
            <b-form-input id="last_name" type="text" v-model="form.last_name" required placeholder="Введите фамилию">
            </b-form-input>
            <div class="text-danger" v-show="errors['last_name']">{{ errors["last_name"] }}</div>
          </b-form-group>
          <b-form-group id="nameInputGroup" label="Имя:" label-for="name">
            <b-form-input id="name" type="text" v-model="form.name" required placeholder="Введите имя"> </b-form-input>
            <div class="text-danger" v-show="errors['name']">{{ errors["name"] }}</div>
          </b-form-group>
          <b-form-group id="second_nameInputGroup" label="Отчество:" label-for="second_name">
            <b-form-input id="second_name" type="text" v-model="form.second_name" placeholder="Введите имя">
            </b-form-input>
            <div class="text-danger" v-show="errors['second_name']">{{ errors["second_name"] }}</div>
          </b-form-group>
          <b-form-group id="birthdayInputGroup" label="Дата рождения:" label-for="birthday">
            <date-picker
              id="birthday"
              v-model="form.birthday"
              :first-day-of-week="1"
              lang="ru"
              :editable="false"
            ></date-picker>
            <div class="text-danger" v-show="errors['birthday']">{{ errors["birthday"] }}</div>
          </b-form-group>
          <b-form-group id="countryInputGroup" label="Страна:" label-for="country">
            <b-form-input id="country" type="text" v-model="form.country" placeholder="Введите страну"> </b-form-input>
            <div class="text-danger" v-show="errors['country']">{{ errors["country"] }}</div>
          </b-form-group>
          <b-form-group id="organizationInputGroup" label="Организация:" label-for="organization">
            <b-form-input
              id="organization"
              type="text"
              v-model="form.organization"
              placeholder="Введите вашу организацию"
            >
            </b-form-input>
            <div class="text-danger" v-show="errors['organization']">{{ errors["organization"] }}</div>
          </b-form-group>
          <b-form-group id="locationInputGroup" label="Адрес" label-for="location">
            <b-form-input id="location" type="text" v-model="form.location" placeholder="Введите ваш рабочий адрес">
            </b-form-input>
            <div class="text-danger" v-show="errors['location']">{{ errors["location"] }}</div>
          </b-form-group>
          <b-form-group id="positionInputGroup" label="Должность" label-for="position">
            <b-form-input id="position" type="text" v-model="form.position" placeholder="Введите вашу должность">
            </b-form-input>
            <div class="text-danger" v-show="errors['position']">{{ errors["position"] }}</div>
          </b-form-group>

          <b-button type="submit" variant="primary">Сохранить</b-button>
        </b-form>
      </b-tab>
      <b-tab title="Настройки доступа" :active="security">
        <security></security>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import "vue-select/dist/vue-select.css";
import DatePicker from "vue2-datepicker";
import "vue-tel-input/dist/vue-tel-input.css";
import security from "./security";
export default {
  name: "profile-settings",
  components: {
    DatePicker,
    security,
  },
  data() {
    return {
      security: false,
      form: {},
      errors: {},
      show: true,
      countries: [],
      organizations: [],
      lengthError: "Значение не должно превышать 40 знаков",
      lengthValidationFields: ["last_name", "second_name", "name"],
    };
  },
  methods: {
    onSubmit() {
      this.errors = {};
      if (this.form.birthday) {
        const birthdayDate = new Date(this.form.birthday);
        const currentDate = new Date();
        if (birthdayDate > currentDate || currentDate.getFullYear() - birthdayDate.getFullYear() > 100) {
          this.errors["birthday"] = "Поле заполнено некорректно";
        }
      }
      this.lengthValidationFields.forEach((field) => {
        if (this.form[field].length > 40) {
          this.errors[field] = this.lengthError;
        }
      });

      if (Object.keys(this.errors).length) {
        return;
      }

      this.$http
        .put("profile/update?id=" + this.$auth.user().id, {
          Profile: this.form,
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          // this.errors = response.data.errors
          if (response.data.errors) {
            this.errors = [];
            for (var prop in response.data.errors) {
              var key = prop.replace("profile-", "");
              this.errors[key] = response.data.errors[prop][0];
            }
          } else {
            this.$auth.user().profile.name = this.form.name;
            this.$auth.user().profile.second_name = this.form.second_name;
            this.$auth.user().profile.last_name = this.form.last_name;
          }
        });
    },
    fetchData() {
      this.$http
        .get("profile/get", {
          params: {
            user_id: this.$auth.user().id,
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.form = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        });
      this.$http.get("profile/get-countries").then((response) => {
        this.countries = Object.keys(response.data).map(function (key) {
          return response.data[key];
        });
      });
    },
    onInput({ isValid }) {
      if (!isValid) {
        this.errors.phone = "Номер телефона введен неверно";
      } else {
        this.errors.phone = "";
      }
    },
  },

  created() {
    this.fetchData();
  },
};
</script>
